import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_5 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_6 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_7 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_8 = { class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-sm" };
const _hoisted_9 = { style: { "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis", "width": "100%" } };
const _hoisted_10 = { style: { "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis", "width": "100%" } };
const _hoisted_11 = { style: { "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis", "width": "100%" } };
const _hoisted_12 = {
    key: 0,
    style: { "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis", "width": "100%" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_my_page_number_input = _resolveComponent("my-page-number-input");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_select = _resolveComponent("q-select");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_expansion_item = _resolveComponent("q-expansion-item");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_td = _resolveComponent("q-td");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_tr = _resolveComponent("q-tr");
    const _component_my_page_table = _resolveComponent("my-page-table");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.top },
                    { itemId: _ctx.keiyakushaList }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_card, { class: "q-mb-lg" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_expansion_item, {
                                            class: "search-expansion",
                                            icon: "search",
                                            label: "検索条件",
                                            modelValue: _ctx.expansionState,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.expansionState) = $event)),
                                            dense: ""
                                        }, {
                                            header: _withCtx(() => [
                                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_icon, { name: "search" })
                                                    ]),
                                                    _: 1
                                                }),
                                                (_ctx.expansionState)
                                                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                                                        key: 0,
                                                        class: "text-large text-weight-bold q-py-sm"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                                _createTextVNode("検索条件 ", -1)
                                                            ]))]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true),
                                                (!_ctx.expansionState)
                                                    ? (_openBlock(), _createBlock(_component_q_item_section, {
                                                        key: 1,
                                                        class: "text-large text-weight-bold q-py-sm display-condition"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.storedCondition.summary), 1)
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_separator),
                                                _createVNode(_component_q_card_section, null, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_3, [
                                                            _createElementVNode("div", _hoisted_4, [
                                                                _cache[9] || (_cache[9] = _createElementVNode("div", null, "契約者コード", -1)),
                                                                _createVNode(_component_my_page_number_input, {
                                                                    "model-value": _ctx.condition.userCd,
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    dense: "",
                                                                    outlined: "",
                                                                    error: _ctx.conditionValid.userCd.error,
                                                                    updateValue: val => _ctx.condition.userCd = val,
                                                                    "no-error-icon": "",
                                                                    "error-message": _ctx.conditionValid.userCd.message,
                                                                    class: "no-spin",
                                                                    "onUpdate:modelValue": _ctx.onChange
                                                                }, null, 8, ["model-value", "error", "updateValue", "error-message", "onUpdate:modelValue"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_5, [
                                                                _cache[10] || (_cache[10] = _createElementVNode("div", null, "契約者名", -1)),
                                                                _createVNode(_component_q_input, {
                                                                    dense: "",
                                                                    outlined: "",
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    modelValue: _ctx.condition.userName,
                                                                    "onUpdate:modelValue": [
                                                                        _cache[0] || (_cache[0] = ($event) => ((_ctx.condition.userName) = $event)),
                                                                        _ctx.onChange
                                                                    ],
                                                                    "no-error-icon": "",
                                                                    error: _ctx.conditionValid.userName.error,
                                                                    "error-message": _ctx.conditionValid.userName.message,
                                                                    onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.condition.isSearch = false))
                                                                }, null, 8, ["modelValue", "error", "error-message", "onUpdate:modelValue"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_6, [
                                                                _cache[11] || (_cache[11] = _createElementVNode("div", null, "契約区分", -1)),
                                                                _createVNode(_component_q_select, {
                                                                    modelValue: _ctx.condition.userKb,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.condition.userKb) = $event)),
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    options: _ctx.userKbList,
                                                                    dense: "",
                                                                    outlined: "",
                                                                    disable: !_ctx.auth.userInfo.isHeadquarters
                                                                }, null, 8, ["modelValue", "options", "disable"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_7, [
                                                                _cache[12] || (_cache[12] = _createElementVNode("div", null, "物件コード", -1)),
                                                                _createVNode(_component_my_page_number_input, {
                                                                    "model-value": _ctx.condition.buknCd,
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    dense: "",
                                                                    outlined: "",
                                                                    error: _ctx.conditionValid.buknCd.error,
                                                                    updateValue: val => _ctx.condition.buknCd = val,
                                                                    "no-error-icon": "",
                                                                    "error-message": _ctx.conditionValid.buknCd.message,
                                                                    class: "no-spin",
                                                                    onChange: _cache[3] || (_cache[3] = ($event) => (_ctx.condition.isSearch = false)),
                                                                    "onUpdate:modelValue": _ctx.onChange
                                                                }, null, 8, ["model-value", "error", "updateValue", "error-message", "onUpdate:modelValue"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_8, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("div", null, "物件名", -1)),
                                                                _createVNode(_component_q_input, {
                                                                    dense: "",
                                                                    outlined: "",
                                                                    clearable: "",
                                                                    "clear-icon": "close",
                                                                    modelValue: _ctx.condition.buknName,
                                                                    "onUpdate:modelValue": [
                                                                        _cache[4] || (_cache[4] = ($event) => ((_ctx.condition.buknName) = $event)),
                                                                        _ctx.onChange
                                                                    ],
                                                                    "no-error-icon": "",
                                                                    error: _ctx.conditionValid.buknName.error,
                                                                    "error-message": _ctx.conditionValid.buknName.message
                                                                }, null, 8, ["modelValue", "error", "error-message", "onUpdate:modelValue"])
                                                            ])
                                                        ])
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_q_separator),
                                                _createVNode(_component_q_card_actions, { class: "row justify-center q-py-md bg-grey-1" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_btn, {
                                                            icon: "search",
                                                            class: "col-8 col-sm-6 col-md-3 col-lg-3",
                                                            label: "検索",
                                                            color: "green-7",
                                                            onClick: _ctx.onSearch
                                                        }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_my_page_table, {
                                    rows: _ctx.results,
                                    columns: _ctx.columns,
                                    executeDate: _ctx.foundDate,
                                    "row-key": "userCd",
                                    pagination: _ctx.pagination,
                                    "onUpdate:pagination": _cache[6] || (_cache[6] = ($event) => ((_ctx.pagination) = $event)),
                                    request: _ctx.onRequest,
                                    enableSelection: false
                                }, {
                                    body: _withCtx((props) => [
                                        _createVNode(_component_q_tr, {
                                            props: props,
                                            onClick: ($event) => (_ctx.onClick(props.row.userCd))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_td, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_icon, {
                                                            name: "edit",
                                                            size: "sm"
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_q_td, { class: "text-left" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.row.userCd), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, {
                                                    class: "text-left",
                                                    style: { "width": "100px", "max-width": "100px" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.userKbText(props.row.userKb)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-center" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", null, [
                                                            (props.row.kankatsuKb === 0)
                                                                ? (_openBlock(), _createBlock(_component_q_badge, {
                                                                    key: 0,
                                                                    class: "chubu-badge"
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                            _createTextVNode("中部", -1)
                                                                        ]))]),
                                                                    _: 1
                                                                }))
                                                                : (_openBlock(), _createBlock(_component_q_badge, {
                                                                    key: 1,
                                                                    class: "kanto-badge"
                                                                }, {
                                                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                            _createTextVNode("関東", -1)
                                                                        ]))]),
                                                                    _: 1
                                                                }))
                                                        ])
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, {
                                                    class: "text-left",
                                                    style: { "width": "250px", "max-width": "250px" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_9, _toDisplayString(props.row.userName), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-left" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.row.buknCd), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, {
                                                    class: "text-left",
                                                    style: { "width": "250px", "max-width": "250px" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_10, _toDisplayString(props.row.buknName), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-left" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.row.roomNo), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, {
                                                    class: "text-left",
                                                    style: { "width": "200px", "max-width": "200px" }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_11, _toDisplayString(props.row.email), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createVNode(_component_q_td, { class: "text-left" }, {
                                                    default: _withCtx(() => [
                                                        (!_ctx.isNullOrUndefined(props.row.loginId))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(props.row.loginId), 1))
                                                            : (_openBlock(), _createBlock(_component_q_badge, {
                                                                key: 1,
                                                                class: "unissued-badge"
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                                        _createTextVNode("未発行", -1)
                                                                    ]))]),
                                                                _: 1
                                                            }))
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1032, ["props", "onClick"])
                                    ]),
                                    _: 1
                                }, 8, ["rows", "columns", "executeDate", "pagination", "request"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
